module.exports = __webpack_public_path__ + "img/chitarra-cerimonia.51bf225e.jpg";